import { gql } from "lib/apolloClient";
import { messageFragment } from "modules/CommonFragments";

export const commentConnectionFragment = {
  commentConnection: gql`
    fragment commentConnectionItem on CommentConnection {
      totalCount
      unreadCount
      unreadCountV2
      pageInfo(first: $first, after: $after) {
        endCursor
        hasNextPage
      }
      edges: messageEdges(first: $first, after: $after) {
        node {
          ...messageItem
        }
      }
    }
    ${messageFragment.message}
  `,
};

export const commentNodeFragment = {
  studentGoalTask: gql`
    fragment studentGoalTaskItem on GoalTask {
      id
      comments {
        ...commentConnectionItem
      }
    }
    ${commentConnectionFragment.commentConnection}
  `,
};
